<template>
    <div>
        <a-form 
            id="factor2-form"
            :form="factor2Form"
            class="factor2Form"
            v-on:submit="formSubmit"
        >
            <a-form-item
                label="SMS-ben kapott token:"
            >
                <a-input
                    v-decorator="[
                        'smscode',
                        {
                            rules: [{
                                required: true,
                                message: 'Kérjük írja be az azonosítót'
                            }]
                        }
                    ]"
                >
                    <a-icon
                        slot="prefix"
                        type="safety"
                        style="color: rgba(0, 0, 0, 0.5)"
                    >

                    </a-icon>
                </a-input>
            </a-form-item>
            <a-divider
                
            ></a-divider>
            <a-form-item>
                <router-link class="to-login"  :to="{name: 'login'}">
                    <span>
                        Vissza a bejelentkezéshez
                    </span>
                </router-link>
                <a-button
                    :loading="loginLoading"
                    type="primary"
                    html-type="submit"
                    class="login-factor2-button"
                >
                    Tovább
                </a-button>
                <div
                    
                >
                    <a-alert
                        v-if="loginError"
                        :message="loginError.message"
                        type="error"
                        :showIcon="true"
                        :closable="true"
                        :banner="true"
                        :afterClose="clearError"
                    />
                </div>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import LocalStorage from '@/helpers/localstorage.js';
import axios from 'axios';
import { USER_LOGIN, SET_FACTOR2 } from '../../store/action_types';
import { SET_SESSION_LENGTH } from '@/store/mutation_types';
import { validateSms } from '../../http/api';
import store from '@/store/store.js';

export default {
    
    beforeRouteEnter(to, from, next) {
        if (!store.state.user_module.factor2.token) {
            next({
                path: '/login',
                replace: true
            })
        } else {
            next();
        }
        
    },

    beforeCreate() {
        this.factor2Form = this.$form.createForm(this);
    },

    data() {
        return {
            loginLoading: false,
            loginError: null
        }
    },

    computed: {
        factor2() {
            return this.$store.state.user_module.factor2;
        }
    },

    methods: {
        formSubmit(e) {
    
            e.preventDefault();
            this.factor2Form.validateFieldsAndScroll((err, vals) => {
                console.log('ERR', err);
                console.log('VALS', vals);
                if (!err) {


                    this.loginLoading = true;
                    
                    const data = {
                        token: this.factor2.token,
                        uuid: this.factor2.uuid,
                        smscode: vals.smscode
                    };

                    validateSms(data).then(res => {
                        const userName = `${res.data.loggedInUser.email}`;
                        const email = res.data.loggedInUser.email;
                        const roles = res.data.loggedInUser.role;
                        const sid = res.data.loggedInUser.sid;
                        const userData = {
                            userName,
                            email,
                            roles,
                            sid
                        }
                        console.log('USERDATA', userData);
                        this.$store.dispatch({
                            type: USER_LOGIN,
                            ...userData
                        })
                        this.$store.commit({
                            type: SET_SESSION_LENGTH,
                            sessionLengthMin: parseInt(res.data.ttlInMinutes)
                        })
                        if(this.factor2.rememberMe === true) {
                            LocalStorage.setUserData({
                                ...userData
                            })
                        }
                        this.$router.push({
                            name: 'app'
                        })

                    })
                    .catch(err => {
                        console.log('SMSERR', err);
                        let status;
                        let message;


                        if (!err.response) {
                            status = err.code
                            message = err.error;
                        } else {
                            status = err.response.data.errors[0].status;
                            message = err.response.data.errors[0].message
                        }

                        this.loginError = {
                            message: `${status}: ${message}`
                        }
                        this.loginLoading = false;
                    })

                    

                    
                }
            })

        },

        clearError() {
            this.loginError = null;
        }
    }
}
</script>

<style lang="scss" scoped>

    .to-login {
        float: right;
    }
    .remember-button {
        float:left;
    }
    .forgotten-form-button {
        width: 100%
    }
</style>
